import { enNamespaces } from './bundled-en';

export type { I18nNamespace, I18nResources } from './bundled-en';
export { I18N_NAMESPACE_KEYS } from './bundled-en';
export {
  DEFAULT_LOCALE,
  I18N_FALLBACK_LOCALE,
  normalizeI18nResolvedLanguage,
  PREFERRED_LOCALE_STORAGE_KEY,
  parseStoredLocale,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from './i18n-locale-constants';

/** English only for initial web bundle; other locales load via i18next backend (see `apps/web`). */
export const resources = {
  en: enNamespaces,
} as const;

export {
  clearPreferredLocale,
  detectInitialLocale,
  persistPreferredLocale,
  readNavigatorLocale,
  readPersistedLocale,
} from './locale-persistence';
export { tStatic } from './t-static';
